import React, { useEffect, useState } from 'react';
import AvalanchePathsTable from './AvalanchePathsTable';
import { BOOTSTRAP_BREAKPOINTS, checkBreakpoint } from '@awp/helpers/UIHelper';
import { debounce } from '@awp/helpers/Utils';
import { AwpContainer } from '../Common/AwpContainer';
import { Permissions } from '@awp/constants';
import Authorize from '@awp/components/Authorize';
import { UrlParamTableFilterContextProvider } from '@providers/UrlParamTableFilterContext';

const AvalanchePathAdmin = () => {
  const [isMedium, setIsMedium] = useState(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.MEDIUM));
  const [isLarge, setIsLarge] = useState(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.LARGE));

  useEffect(() => {
    const handleResize = debounce(() => {
      setIsMedium(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.MEDIUM));
      setIsLarge(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.LARGE));
    }, 100);

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  });

  const tableProps = {
    isLarge,
    isMedium,
  };

  return (
    <AwpContainer>
      <Authorize requires={[Permissions.ReadAdminTools]}>
        <UrlParamTableFilterContextProvider>
          <AvalanchePathsTable {...tableProps} />
        </UrlParamTableFilterContextProvider>
      </Authorize>
    </AwpContainer>
  );
};

export default AvalanchePathAdmin;
